export const CHANGE_LOGIN = 'login/CHANGE_LOGIN';
export const GROPOUT = 'login/GROPOUT';
export const STOP_LOADING = 'login/STOP_LOADING';
export const START_LOADING = 'login/START_LOADING';
export const LOGIN_TRUE = 'login/LOGIN_TRUE';
export const LOGIN_FALSE = 'login/LOGIN_FALSE';